import { React, useContext, useState, useEffect } from "react";
import { usePageLoading } from "hooks/usePageLoading";
// import backgroundImage from "../../assets/img/landing-background.png";

const Landing = (props) => {
  const doneLoading = usePageLoading(props);

  useEffect(() => {
    doneLoading(); // no hay datos que traer
  }, []);

  return (
    <>
      <div className="page-header header-filter">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/landing-background.png") + ")",
          }}
        ></div>
      </div>
    </>
  );
};

export default Landing;
